import { render, staticRenderFns } from "./BidPlacedMessage.vue?vue&type=template&id=43498846&scoped=true&"
import script from "./BidPlacedMessage.vue?vue&type=script&lang=js&"
export * from "./BidPlacedMessage.vue?vue&type=script&lang=js&"
import style0 from "./BidPlacedMessage.vue?vue&type=style&index=0&id=43498846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43498846",
  null
  
)

export default component.exports